import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=9172808c&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"
import style0 from "./CategoryView.vue?vue&type=style&index=0&id=9172808c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9172808c",
  null
  
)

export default component.exports